import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/string-list';
import ListGroupHeaderComponent from "./components/string-group-list-header";
import ViewComponent from './components/string-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from './components/string-form-new';
import FieldTextViewInImport from "../../import/view-in-preview/long-text-view-in-preview";

export default class TextCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);
    }

    /*listItemGroupFunction() {
        return i=>{
            let res = i.item.customFieldsData[this.customField.id];
            return res ? res : null;
        }
    }*/

    getCsvValue(item) {
        const { customFieldsData } = item;
        return !!customFieldsData[this.customField.id] ? customFieldsData[this.customField.id] : '';
    }

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!i.item.customFieldsData[this.customField.id] ? 1 : 2,
                i => i.item.customFieldsData[this.customField.id] || ''
            ],
            directions: ['asc', sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    // IMPORT

    normalizeCSVValue(value) {
        return value?value.trim():null;
    }

    getComponentViewInImport() {
        return FieldTextViewInImport;
    }

}